export default {
  1.001: [
    '1/1000',
    '-100000',
    '0.001',
    '-1000.00',
    '0.001'
  ],
  1.005: [
    '1/200',
    '-20000',
    '0.005',
    '-200.00',
    '0.005'
  ],
  '1.010': [
    '1/100',
    '-10000',
    '0.01',
    '-100.00',
    '0.01'
  ],
  '1.020': [
    '1/50',
    '-5000',
    '0.02',
    '-50.00',
    '0.02'
  ],
  '1.030': [
    '1/34',
    '-3400',
    '0.03',
    '-34.00',
    '0.03'
  ],
  '1.040': [
    '1/25',
    '-2500',
    '0.04',
    '-25.00',
    '0.04'
  ],
  '1.050': [
    '1/20',
    '-2000',
    '0.05',
    '-20.00',
    '0.05'
  ],
  '1.060': [
    '1/20',
    '-1700',
    '0.06',
    '-17.00',
    '0.06'
  ],
  '1.070': [
    '1/15',
    '-1500',
    '0.07',
    '-15.00',
    '0.07'
  ],
  '1.080': [
    '1/13',
    '-1250',
    '0.08',
    '-12.50',
    '0.08'
  ],
  '1.090': [
    '1/13',
    '-1150',
    '0.09',
    '-11.50',
    '0.09'
  ],
  '1.100': [
    '1/10',
    '-1000',
    '0.10',
    '-10.00',
    '0.10'
  ],
  '1.110': [
    '1/10',
    '-950',
    '0.11',
    '-9.50',
    '0.11'
  ],
  '1.120': [
    '3/25',
    '-850',
    '0.12',
    '-8.50',
    '0.12'
  ],
  '1.130': [
    '1/8',
    '-775',
    '0.13',
    '-7.75',
    '0.13'
  ],
  '1.140': [
    '1/8',
    '-725',
    '0.14',
    '-7.25',
    '0.14'
  ],
  '1.150': [
    '3/20',
    '-675',
    '0.15',
    '-6.75',
    '0.15'
  ],
  '1.160': [
    '3/20',
    '-625',
    '0.16',
    '-6.25',
    '0.16'
  ],
  '1.170': [
    '3/20',
    '-600',
    '0.17',
    '-6.00',
    '0.17'
  ],
  '1.180': [
    '1/6',
    '-575',
    '0.18',
    '-5.75',
    '0.18'
  ],
  '1.190': [
    '1/6',
    '-550',
    '0.19',
    '-5.50',
    '0.19'
  ],
  '1.200': [
    '1/5',
    '-500',
    '0.20',
    '-5.00',
    '0.20'
  ],
  '1.210': [
    '1/5',
    '-500',
    '0.21',
    '-5.00',
    '0.21'
  ],
  '1.220': [
    '1/5',
    '-475',
    '0.22',
    '-4.75',
    '0.22'
  ],
  '1.230': [
    '3/14',
    '-450',
    '0.23',
    '-4.50',
    '0.23'
  ],
  '1.240': [
    '3/14',
    '-425',
    '0.24',
    '-4.25',
    '0.24'
  ],
  '1.250': [
    '1/4',
    '-400',
    '0.25',
    '-4.00',
    '0.25'
  ],
  '1.260': [
    '1/4',
    '-385',
    '0.26',
    '-3.85',
    '0.26'
  ],
  '1.270': [
    '4/15',
    '-375',
    '0.27',
    '-3.75',
    '0.27'
  ],
  '1.280': [
    '4/15',
    '-360',
    '0.28',
    '-3.60',
    '0.28'
  ],
  '1.290': [
    '4/15',
    '-345',
    '0.29',
    '-3.45',
    '0.29'
  ],
  '1.300': [
    '3/10',
    '-335',
    '0.30',
    '-3.35',
    '0.30'
  ],
  '1.310': [
    '3/10',
    '-325',
    '0.31',
    '-3.25',
    '0.31'
  ],
  '1.320': [
    '3/10',
    '-315',
    '0.32',
    '-3.15',
    '0.32'
  ],
  '1.330': [
    '8/25',
    '-305',
    '0.33',
    '-3.05',
    '0.33'
  ],
  '1.340': [
    '8/25',
    '-295',
    '0.34',
    '-2.95',
    '0.34'
  ],
  '1.350': [
    '7/20',
    '-290',
    '0.35',
    '-2.90',
    '0.35'
  ],
  '1.370': [
    '4/11',
    '-275',
    '0.37',
    '-2.75',
    '0.37'
  ],
  '1.400': [
    '2/5',
    '-250',
    '0.40',
    '-2.50',
    '0.40'
  ],
  '1.430': [
    '3/7',
    '-235',
    '0.43',
    '-2.35',
    '0.43'
  ],
  '1.450': [
    '4/9',
    '-225',
    '0.45',
    '-2.25',
    '0.45'
  ],
  '1.470': [
    '7/15',
    '-215',
    '0.47',
    '-2.15',
    '0.47'
  ],
  '1.480': [
    '12/25',
    '-210',
    '0.48',
    '-2.10',
    '0.48'
  ],
  '1.500': [
    '1/2',
    '-200',
    '0.50',
    '-2.00',
    '0.50'
  ],
  '1.530': [
    '9/17',
    '-190',
    '0.53',
    '-1.90',
    '0.53'
  ],
  '1.550': [
    '11/20',
    '-185',
    '0.55',
    '-1.85',
    '0.55'
  ],
  '1.570': [
    '5/9',
    '-180',
    '0.57',
    '-1.80',
    '0.57'
  ],
  '1.600': [
    '3/5',
    '-170',
    '0.60',
    '-1.70',
    '0.60'
  ],
  '1.630': [
    '5/8',
    '-160',
    '0.63',
    '-1.60',
    '0.63'
  ],
  '1.650': [
    '13/20',
    '-155',
    '0.65',
    '-1.55',
    '0.65'
  ],
  '1.670': [
    '2/3',
    '-150',
    '0.67',
    '-1.50',
    '0.67'
  ],
  '1.700': [
    '7/10',
    '-145',
    '0.70',
    '-1.45',
    '0.70'
  ],
  '1.720': [
    '5/7',
    '-139',
    '0.72',
    '-1.39',
    '0.72'
  ],
  '1.730': [
    '8/11',
    '-137',
    '0.73',
    '-1.37',
    '0.73'
  ],
  '1.750': [
    '3/4',
    '-134',
    '0.75',
    '-1.34',
    '0.75'
  ],
  '1.770': [
    '10/13',
    '-130',
    '0.77',
    '-1.30',
    '0.77'
  ],
  '1.790': [
    '11/14',
    '-127',
    '0.79',
    '-1.27',
    '0.79'
  ],
  '1.800': [
    '4/5',
    '-125',
    '0.80',
    '-1.25',
    '0.80'
  ],
  '1.810': [
    '4/5',
    '-124',
    '0.81',
    '-1.24',
    '0.81'
  ],
  '1.820': [
    '9/11',
    '-122',
    '0.82',
    '-1.22',
    '0.82'
  ],
  '1.830': [
    '9/11',
    '-121',
    '0.83',
    '-1.21',
    '0.83'
  ],
  '1.840': [
    '5/6',
    '-120',
    '0.84',
    '-1.20',
    '0.84'
  ],
  '1.850': [
    '17/20',
    '-118',
    '0.85',
    '-1.18',
    '0.85'
  ],
  '1.860': [
    '6/7',
    '-117',
    '0.86',
    '-1.17',
    '0.86'
  ],
  '1.870': [
    '13/15',
    '-115',
    '0.87',
    '-1.15',
    '0.87'
  ],
  '1.880': [
    '7/8',
    '-114',
    '0.88',
    '-1.14',
    '0.88'
  ],
  '1.890': [
    '8/9',
    '-113',
    '0.89',
    '-1.13',
    '0.89'
  ],
  '1.900': [
    '9/10',
    '-112',
    '0.90',
    '-1.12',
    '0.90'
  ],
  '1.910': [
    '10/11',
    '-110',
    '0.91',
    '-1.10',
    '0.91'
  ],
  '1.920': [
    '11/12',
    '-109',
    '0.92',
    '-1.09',
    '0.92'
  ],
  '1.930': [
    '13/14',
    '-108',
    '0.93',
    '-1.08',
    '0.93'
  ],
  '1.940': [
    '15/16',
    '-107',
    '0.94',
    '-1.07',
    '0.94'
  ],
  '1.950': [
    '19/20',
    '-106',
    '0.95',
    '-1.06',
    '0.95'
  ],
  '1.960': [
    '24/25',
    '-105',
    '0.96',
    '-1.05',
    '0.96'
  ],
  '1.970': [
    '29/30',
    '-104',
    '0.97',
    '-1.04',
    '0.97'
  ],
  '1.980': [
    '49/50',
    '-103',
    '0.98',
    '-1.03',
    '0.98'
  ],
  '1.990': [
    '99/100',
    '-102',
    '0.99',
    '-1.02',
    '0.99'
  ],
  '2.000': [
    '1/1',
    '+100',
    '1.00',
    '+1',
    '1.00'
  ],
  '2.050': [
    '21/20',
    '+105',
    '1.05',
    '+1.05',
    '-0.96'
  ],
  '2.100': [
    '11/10',
    '+110',
    '1.10',
    '+1.10',
    '-0.91'
  ],
  '2.150': [
    '23/20',
    '+115',
    '1.15',
    '+1.15',
    '-0.87'
  ],
  '2.200': [
    '6/5',
    '+120',
    '1.20',
    '+1.20',
    '-0.84'
  ],
  '2.250': [
    '5/4',
    '+125',
    '1.25',
    '+1.25',
    '-0.80'
  ],
  '2.300': [
    '13/10',
    '+130',
    '1.30',
    '+1.30',
    '-0.77'
  ],
  '2.350': [
    '27/20',
    '+135',
    '1.35',
    '+1.35',
    '-0.75'
  ],
  '2.400': [
    '7/5',
    '+140',
    '1.40',
    '+1.40',
    '-0.72'
  ],
  '2.450': [
    '29/20',
    '+145',
    '1.45',
    '+1.45',
    '-0.69'
  ],
  '2.500': [
    '6/4',
    '+150',
    '1.50',
    '+1.50',
    '-0.67'
  ],
  '2.550': [
    '31/20',
    '+155',
    '1.55',
    '+1.55',
    '-0.65'
  ],
  '2.600': [
    '8/5',
    '+160',
    '1.60',
    '+1.60',
    '-0.63'
  ],
  '2.650': [
    '33/20',
    '+165',
    '1.65',
    '+1.65',
    '-0.61'
  ],
  '2.700': [
    '17/10',
    '+170',
    '1.70',
    '+1.70',
    '-0.59'
  ],
  '2.750': [
    '7/4',
    '+175',
    '1.75',
    '+1.75',
    '-0.58'
  ],
  '2.800': [
    '9/5',
    '+180',
    '1.80',
    '+1.80',
    '-0.56'
  ],
  '2.850': [
    '37/20',
    '+185',
    '1.85',
    '+1.85',
    '-0.55'
  ],
  '2.900': [
    '19/10',
    '+190',
    '1.90',
    '+1.90',
    '-0.53'
  ],
  '2.950': [
    '39/20',
    '+195',
    '1.95',
    '+1.95',
    '-0.52'
  ],
  '3.000': [
    '2/1',
    '+200',
    '2.00',
    '+2.00',
    '-0.50'
  ],
  '3.100': [
    '21/10',
    '+210',
    '2.10',
    '+2.10',
    '-0.48'
  ],
  '3.200': [
    '11/5',
    '+220',
    '2.20',
    '+2.20',
    '-0.46'
  ],
  '3.300': [
    '23/10',
    '+230',
    '2.30',
    '+2.30',
    '-0.44'
  ],
  '3.400': [
    '12/5',
    '+240',
    '2.40',
    '+2.40',
    '-0.42'
  ],
  '3.500': [
    '5/2',
    '+250',
    '2.50',
    '+2.50',
    '-0.40'
  ],
  '3.600': [
    '13/5',
    '+260',
    '2.60',
    '+2.60',
    '-0.39'
  ],
  '3.700': [
    '27/10',
    '+270',
    '2.70',
    '+2.70',
    '-0.38'
  ],
  '3.800': [
    '14/5',
    '+280',
    '2.80',
    '+2.80',
    '-0.36'
  ],
  '3.900': [
    '29/10',
    '+290',
    '2.90',
    '+2.90',
    '-0.35'
  ],
  '4.000': [
    '3/1',
    '+300',
    '3.00',
    '+3.00',
    '-0.34'
  ],
  '4.100': [
    '31/10',
    '+310',
    '3.10',
    '+3.10',
    '-0.33'
  ],
  '4.200': [
    '16/5',
    '+320',
    '3.20',
    '+3.20',
    '-0.32'
  ],
  '4.300': [
    '33/10',
    '+330',
    '3.30',
    '+3.30',
    '-0.31'
  ],
  '4.400': [
    '17/5',
    '+340',
    '3.40',
    '+3.40',
    '-0.30'
  ],
  '4.500': [
    '7/2',
    '+350',
    '3.50',
    '+3.50',
    '-0.29'
  ],
  '4.600': [
    '18/5',
    '+360',
    '3.60',
    '+3.60',
    '-0.28'
  ],
  '4.700': [
    '37/10',
    '+370',
    '3.70',
    '+3.70',
    '-0.28'
  ],
  '4.800': [
    '19/5',
    '+380',
    '3.80',
    '+3.80',
    '-0.27'
  ],
  '4.900': [
    '39/10',
    '+390',
    '3.90',
    '+3.90',
    '-0.26'
  ],
  '5.000': [
    '4/1',
    '+400',
    '4.00',
    '+4.00',
    '-0.25'
  ],
  '5.250': [
    '17/4',
    '+425',
    '4.25',
    '+4.25',
    '-0.24'
  ],
  '5.500': [
    '9/2',
    '+450',
    '4.50',
    '+4.50',
    '-0.23'
  ],
  '5.750': [
    '19/4',
    '+475',
    '4.75',
    '+4.75',
    '-0.22'
  ],
  '6.000': [
    '5/1',
    '+500',
    '5.00',
    '+5.00',
    '-0.20'
  ],
  '6.250': [
    '21/4',
    '+525',
    '5.25',
    '+5.25',
    '-0.20'
  ],
  '6.500': [
    '11/2',
    '+550',
    '5.50',
    '+5.50',
    '-0.19'
  ],
  '6.750': [
    '23/4',
    '+575',
    '5.75',
    '+5.75',
    '-0.18'
  ],
  '7.000': [
    '6/1',
    '+600',
    '6.00',
    '+6.00',
    '-0.17'
  ],
  '7.250': [
    '25/4',
    '+625',
    '6.25',
    '+6.25',
    '-0.16'
  ],
  '7.500': [
    '13/2',
    '+650',
    '6.50',
    '+6.50',
    '-0.16'
  ],
  '7.750': [
    '27/4',
    '+675',
    '6.75',
    '+6.75',
    '-0.15'
  ],
  '8.000': [
    '7/1',
    '+700',
    '7.00',
    '+7.00',
    '-0.15'
  ],
  '8.250': [
    '29/4',
    '+725',
    '7.25',
    '+7.25',
    '-0.14'
  ],
  '8.500': [
    '15/2',
    '+750',
    '7.50',
    '+7.50',
    '-0.14'
  ],
  '8.750': [
    '31/4',
    '+775',
    '7.75',
    '+7.75',
    '-0.13'
  ],
  '9.000': [
    '8/1',
    '+800',
    '8.00',
    '+8.00',
    '-0.13'
  ],
  '9.250': [
    '33/4',
    '+825',
    '8.25',
    '+8.25',
    '-0.13'
  ],
  '9.500': [
    '17/2',
    '+850',
    '8.50',
    '+8.50',
    '-0.12'
  ],
  '9.750': [
    '35/4',
    '+875',
    '8.75',
    '+8.75',
    '-0.12'
  ],
  '10.000': [
    '9/1',
    '+900',
    '9.00',
    '+9.00',
    '-0.12'
  ],
  '10.500': [
    '19/2',
    '+950',
    '9.50',
    '+9.50',
    '-0.11'
  ],
  '11.000': [
    '10/1',
    '+1000',
    '10.00',
    '+10.00',
    '-0.10'
  ],
  '12.000': [
    '11/1',
    '+1100',
    '11.00',
    '+11.00',
    '-0.10'
  ],
  '13.000': [
    '12/1',
    '+1200',
    '12.00',
    '+12.00',
    '-0.09'
  ],
  '14.000': [
    '13/1',
    '+1300',
    '13.00',
    '+13.00',
    '-0.08'
  ],
  '15.000': [
    '14/1',
    '+1400',
    '14.00',
    '+14.00',
    '-0.08'
  ],
  '16.000': [
    '15/1',
    '+1500',
    '15.00',
    '+15.00',
    '-0.07'
  ],
  '17.000': [
    '16/1',
    '+1600',
    '16.00',
    '+16.00',
    '-0.07'
  ],
  '18.000': [
    '17/1',
    '+1700',
    '17.00',
    '+17.00',
    '-0.06'
  ],
  '19.000': [
    '18/1',
    '+1800',
    '18.00',
    '+18.00',
    '-0.06'
  ],
  '20.000': [
    '19/1',
    '+1900',
    '19.00',
    '+19.00',
    '-0.06'
  ],
  '21.000': [
    '20/1',
    '+2000',
    '20.00',
    '+20.00',
    '-0.05'
  ],
  '23.000': [
    '22/1',
    '+2200',
    '22.00',
    '+22.00',
    '-0.05'
  ],
  '26.000': [
    '25/1',
    '+2500',
    '25.00',
    '+25.00',
    '-0.04'
  ],
  '29.000': [
    '28/1',
    '+2800',
    '28.00',
    '+28.00',
    '-0.04'
  ],
  '31.000': [
    '30/1',
    '+3000',
    '30.00',
    '+30.00',
    '-0.04'
  ],
  '34.000': [
    '33/1',
    '+3300',
    '33.00',
    '+33.00',
    '-0.04'
  ],
  '36.000': [
    '35/1',
    '+3500',
    '35.00',
    '+35.00',
    '-0.03'
  ],
  '41.000': [
    '40/1',
    '+4000',
    '40.00',
    '+40.00',
    '-0.03'
  ],
  '46.000': [
    '45/1',
    '+4500',
    '45.00',
    '+45.00',
    '-0.03'
  ],
  '51.000': [
    '50/1',
    '+5000',
    '50.00',
    '+50.00',
    '-0.02'
  ],
  '56.000': [
    '55/1',
    '+5500',
    '55.00',
    '+55.00',
    '-0.02'
  ],
  '61.000': [
    '60/1',
    '+6000',
    '60.00',
    '+60.00',
    '-0.02'
  ],
  '66.000': [
    '65/1',
    '6500',
    '65.00',
    '+65.00',
    '-0.02'
  ],
  '71.000': [
    '70/1',
    '+7000',
    '70.00',
    '+70.00',
    '-0.02'
  ],
  '81.000': [
    '80/1',
    '+8000',
    '80.00',
    '+80.00',
    '-0.02'
  ],
  '91.000': [
    '90/1',
    '+9000',
    '90.00',
    '+90.00',
    '-0.02'
  ],
  '101.000': [
    '100/1',
    '+10000',
    '100.00',
    '+100.00',
    '-0.01'
  ],
  '111.000': [
    '110/1',
    '+11000',
    '110.00',
    '+110.00',
    '-0.01'
  ],
  '126.000': [
    '125/1',
    '+12500',
    '125.00',
    '+125.00',
    '-0.01'
  ],
  '151.000': [
    '150/1',
    '+15000',
    '150.00',
    '+150.00',
    '-0.01'
  ],
  '176.000': [
    '175/1',
    '+17500',
    '175.00',
    '+175.00',
    '-0.01'
  ],
  '201.000': [
    '200/1',
    '+20000',
    '200.00',
    '+200.00',
    '-0.01'
  ],
  '226.000': [
    '225/1',
    '+22500',
    '225.00',
    '+225.00',
    '-0.01'
  ],
  '251.000': [
    '250/1',
    '+25000',
    '250.00',
    '+250.00',
    '-0.01'
  ],
  '276.000': [
    '275/1',
    '+27500',
    '275.00',
    '+275.00',
    '-0.01'
  ],
  '301.000': [
    '300/1',
    '+30000',
    '300.00',
    '+300.00',
    '-0.01'
  ],
  '351.000': [
    '350/1',
    '+35000',
    '350.00',
    '+350.00',
    '-0.01'
  ],
  '401.000': [
    '400/1',
    '+40000',
    '400.00',
    '+400.00',
    '-0.01'
  ],
  '501.000': [
    '500/1',
    '+50000',
    '500.00',
    '+500.00',
    '-0.01'
  ],
  '751.000': [
    '750/1',
    '+75000',
    '750.00',
    '+750.00',
    '-0.01'
  ],
  '1001.000': [
    '1000/1',
    '+100000',
    '1000.00',
    '+1000.00',
    '-0.01'
  ],
  '2001.000': [
    '2000/1',
    '+200000',
    '2000.00',
    '+2000.00',
    '-0.01'
  ],
  '3001.000': [
    '3000/1',
    '+300000',
    '3000.00',
    '+3000.00',
    '-0.01'
  ],
  '5001.000': [
    '5000/1',
    '+500000',
    '5000.00',
    '+5000.00',
    '-0.01'
  ],
  '10001.000': [
    '10000/1',
    '+1000000',
    '10000.00',
    '+10000.00',
    '-0.01'
  ]
}
